import { render, staticRenderFns } from "./ConfigurazioneMacchine.vue?vue&type=template&id=a10e5dce&scoped=true&"
import script from "./ConfigurazioneMacchine.vue?vue&type=script&lang=js&"
export * from "./ConfigurazioneMacchine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10e5dce",
  null
  
)

export default component.exports